@if (contact) {
  <p-panel>
    <div class="flex items-center mb-3">
      <div class="flex">
        <i
          class="pi pi-angle-double-left cursor-pointer"
          style="color: #7e9c30; font-size: 2rem"
          (click)="goBack()"
        ></i>
      </div>
      <div class="px-4">
        <i class="pi pi-user" style="font-size: 2rem"></i>
      </div>
      <div class="flex px-4">
        {{ contact?.firstname }} {{ contact?.lastName }}
        @if (contact.companyName) {
          <span> ({{ contact.companyName }})</span>
        }
      </div>
      <div class="flex justify-end w-full items-center">
        <p-button (click)="openEditDialog()" icon="pi pi-pen-to-square" label="{{ 'edit' | transloco }}"/>
      </div>
    </div>
    <div>
      <p-tabs [value]="selectedTabIndex" (valueChange)="onTabOpenChange($event)">
        <p-tablist>
          <p-tab [value]="0">{{ 'animalDetails.general.headline' | transloco }}</p-tab>
          <p-tab [value]="1">Zugehörige Tiere</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            <p-panel>
              <app-choose-contact
                [onlyEditContact]="true"
                [newContact]="contact"
                [editingDisabled]="true"
              />
            </p-panel>
          </p-tabpanel>
          <p-tabpanel [value]="1">
            <p-panel>
              <div class="grid grid-cols-12 gap-2">
                <div class="col-span-12">
                  @if (loadingRelations) {
                    <p-panel>
                      <div class="py-6 text-center text-gray-500">
                        <i class="pi pi-spin pi-spinner mr-2"></i>
                        Lädt Zuordnungen...
                      </div>
                    </p-panel>
                  }

                  @if (!loadingRelations && relationGroups.length === 0) {
                    <div class="w-full text-center py-4 text-color-secondary">
                      Keine zugehörigen Tiere vorhanden
                    </div>
                  }

                  @if (!loadingRelations && relationGroups.length > 0) {
                    <p-accordion 
                      [multiple]="true"
                      [value]="accordionValue"
                    >
                      @for (group of relationGroups; track group.key; let idx = $index) {
                        <p-accordion-panel [value]="idx.toString()">
                          <p-accordion-header>
                            {{ group.label }}
                          </p-accordion-header>
                          <p-accordion-content>
                            <app-animal-list-item
                              [animals]="group.animals"
                              [preloadedContext]="group.context"
                              [pageable]="false"
                              [hideDetails]="true"
                            ></app-animal-list-item>
                          </p-accordion-content>
                        </p-accordion-panel>
                      }
                    </p-accordion>
                  }
                </div>
              </div>
            </p-panel>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </p-panel>
}

<p-dialog
  [(visible)]="openEdit"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="openEdit = false"
>
  <ng-template pTemplate="closeicon">
    <span class="closeicon pi pi-times"></span>
  </ng-template>
  <ng-template pTemplate="header">{{ 'contacts.editDialog.headline' | transloco }}</ng-template>
  <ng-template pTemplate="content">
    <div class="p-2">
      <app-choose-contact
        [onlyEditContact]="true"
        [newContact]="editingContact"
        [isExistingContact]="true"
        (validationStatusChanged)="onValidationStatusChanged($event)"
        (existingContactUpdated)="onExistingContactUpdated($event)"
      />
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        (click)="openEdit = false"
        icon="pi pi-times"
        [text]="true"
        label="{{ 'modal.cancel' | transloco }}"
      />
      <p-button
        (click)="save()"
        [disabled]="!validationStatusChanged"
        icon="pi pi-save"
        label="{{ 'modal.save' | transloco }}"
      />
    </div>
  </ng-template>
</p-dialog>
